import actionTypes from "./actions/actionTypes";

const {
  REQUEST_INVITATIONS,
  RECIEVE_INVITATIONS,
  CLEAR_ERRORS,
  SERVER_ERROR_OCURED,
} = actionTypes;

const invitationsReducer = (
  state = {
    isFetchingList: false,
    invitations: [],
    errros: {},
    msg: "",
    hasServerError: false,
    success: false,
  },
  action
) => {
  switch (action.type) {
    case REQUEST_INVITATIONS:
      return Object.assign({}, state, {
        isFetchingList: true,
        hasServerError: false,
        errors: {},
        success: false,
        msg: "",
      });
    case RECIEVE_INVITATIONS:
      return Object.assign({}, state, {
        isFetchingList: false,
        invitations: action.invitations,
      });
    case CLEAR_ERRORS:
      return Object.assign({}, state, {
        hasServerError: false,
        errors: {},
        success: false,
        msg: "",
      });
    case SERVER_ERROR_OCURED:
      return Object.assign({}, state, {
        hasServerError: true,
        errors: action.errors,
        success: false,
      });
    default:
      return state;
  }
};

export default invitationsReducer;



// WEBPACK FOOTER //
// src/routes/Invitations/reducer.js